/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState, useRef } from 'react';

import PropTypes from 'prop-types';
import _ from 'lodash';

import { Td } from './css';
import FieldGuide from '../../../../form/fields/common/fieldGuide';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';
import getFormattedPricing from '../../utils';

const Row = ({
  rowData,
  viewType,
  hardware,
  setHardware
}) => {
  const {
    fields: {
      hardwareName,
      hardwareId,
      hardwareHasIncludedUnits,
      unitPrice,
      toolTip,
      hideForSimpleView,
      isAccessory,
      isRavenAccessory
    }
  } = rowData;

  if (viewType === 'simpleView' && hideForSimpleView) return null;

  const localizedStrings = useLocalizedStringsContext();
  const {
    contentfulValues: { value3year, value2year, valueMTM },
    iotOrderDetailsSection: { labelGoAnywhere }
  } = localizedStrings;

  const [includedQuantity, setIncludedQuantity] = useState(0);
  const [additionalQuantity, setAdditionalQuantity] = useState(() =>
    _.get(hardware, `${hardwareName}.additionalQuantity`, 0)
  );
  const isComponentMounted = useRef(false);
  const rowRef = useRef(false);
  
  useEffect(() => {
    if (!isComponentMounted.current) {
      isComponentMounted.current = true;
      return;
    }

    setHardware(previousValue => ({
      ...previousValue,
      [hardwareName]: {
        ...previousValue[hardwareName],
        includedQuantity,
        additionalQuantity,
        unitPrice,
        isAccessory,
        isRavenAccessory
      }
    }));
  }, [additionalQuantity, unitPrice]);

  useEffect(() => {
    if (viewType && rowRef.current) {
      setAdditionalQuantity(0);
      setIncludedQuantity(0);
    }
    rowRef.current = true;
  }, [viewType]);

  return (
    <tr>
      <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            textAlign: 'left',
            width: '100%'
          }}
        >
          <p style={{ lineHeight: 'normal' }}>
            {hardwareName === 'TB1-LTMTEL' ? labelGoAnywhere : hardwareName}
          </p>
          {toolTip && (
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
              <FieldGuide isRichText tooltip={toolTip} />
            </div>
          )}
        </div>
      </Td>

      <Td>
        <input
          className="frg-input-field color-light"
          pattern="[0-9]"
          value={additionalQuantity}
          onChange={e => {
            setAdditionalQuantity(+e.target.value);
          }}
        />
      </Td>

      <Td>{getFormattedPricing(unitPrice)}</Td>
      <Td>{getFormattedPricing(+unitPrice * additionalQuantity)}</Td>
    </tr>
  );
};

Row.propTypes = {
  rowData: PropTypes.shape({
    fields: PropTypes.shape({
      hardwareName: PropTypes.string,
      hardwareId: PropTypes.string,
      hardwareHasIncludedUnits: PropTypes.bool,
      unitPrice: PropTypes.number,
      toolTip: PropTypes.shape({
        data: PropTypes.object,
        content: PropTypes.array,
        nodeType: PropTypes.string
      }),
      hideForSimpleView: PropTypes.bool.isRequired,
      isAccessory: PropTypes.bool.isRequired,
      isRavenAccessory: PropTypes.bool.isRequired
    })
  }).isRequired,
  viewType: PropTypes.string.isRequired,
  hardware: PropTypes.arrayOf(PropTypes.object).isRequired,
  setHardware: PropTypes.func.isRequired
};

export default Row;
